const backendproff = [
  "Node.js",
  "Express.js",
  "MySQL",
  "Sequelize ORM",
  "MongoDB",
  "Mongoose ODM",
  "GraphQL",
  "Apollo",
  "APIS",
  "JSON",
  "JWT",
  "Stripe",
  "Paypal",
  "Cloudinary",
];

export default backendproff;
